"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internal_1 = require("./internal");
exports.convertDateToBurstTime = (date) => {
    return Math.round(date.getTime() / 1000) - internal_1.GenesisBlockTime;
};
//# sourceMappingURL=convertDateToBurstTime.js.map